export default {
sets: `Zestawy`,
stats: `Statystyka`,
discover: `Odkryć`,
guides: `Przewodnicy`,
settings: `Ustawienia`,
unsupportedBrowserBody: `Flashcards nie obsługuje tej przeglądarki. Pobierz najnowszą wersję Chrome lub Opera lub pobierz naszą aplikację iPhone lub Android`,
unsupportedBrowserTitle: `Nieobsługiwane przeglądarki`,
noData: `Brak danych do pokazania`,
contactUsTitle: `Uwielbiamy słyszeć, w jaki sposób nasi użytkownicy korzystają z naszej aplikacji i jak możemy poprawić. Napisz do nas wiadomość z wszelkimi zapytaniami, takimi jak żądania funkcji lub raporty o błędach`,
rateAppStore: `Oceń w Appstore`,
rateGoogle: `Oceń w Google Play`,
close: `Blisko`,
shareFriends: `Podziel się z przyjaciółmi`,
noCardsQ: `Nie masz żadnych fiszek?`,
noCardsS: `Wybierz z naszej kolekcji, aby rozpocząć`,
suggestSet: `Zaproponuj zestaw`,
createOwn: `Stwórz swój własny`,
search: `Szukaj`,
loading: `Ładowanie`,
words: `Słowa`,
downloads: `Pobierania`,
export: `Eksport`,
import: `Import`,
importing: `Importowanie ... nie zamykaj aplikacji`,
importPreview: `Podgląd importu`,
howQuizlet: `Jak importować z Quizlet`,
cards: `Karty`,
importPreviewStatus: `__ Warunki są gotowe do dołączenia do istniejących kart ___`,
importPaste: `Wklej swoje karty w powyższym texarea`,
setTotalLimitReached: `Możesz mieć tylko 3000 kart w studiach`,
studying: `Uczenie się`,
learnt: `Nauczyliśmy`,
mastered: `Opanowany`,
new: `Nowy`,
noTerm: `Brak terminu`,
noDef: `Brak definicji`,
cardSaved: `Zapisano kartę`,
reviews: `Opinie`,
practices: `Praktyki`,
flashcards: `Fiszki`,
alerts: `Alerty`,
corrects: `Koryguje`,
mistakes: `Błędy`,
reviewCycle: `Cykl przeglądu`,
reviewsLeft: `Recenzje pozostawione`,
lastReview: `Ostatnia recenzja`,
nextReview: `Następna recenzja`,
hideHistory: `Ukryj pełną historię`,
showHistory: `Pokaż pełną historię`,
strength: `Wytrzymałość`,
star: `Gwiazda`,
image: `Obraz`,
tag: `Etykietka`,
added: `dodany`,
removed: `REMOVED`,
reviewedFrom: `Recenzowane z __`,
notifications: `Powiadomienia`,
reviewedPractice: `Sprawdzone __ przez ___ ćwiczyć`,
successfully: `z powodzeniem`,
unsuccessfully: `bezskutecznie`,
termUpdated: `Termin zaktualizowany`,
defUpdated: `Zaktualizowano definicję`,
flashcardCreated: `FlashCard utworzony`,
dropboxImage: `Musisz włączyć synchronizację Dropbox, aby dodawać obrazy`,
deleteImgConfirm: `Czy na pewno chcesz usunąć ten obraz?`,
uploading: `Przesyłanie`,
save: `Ratować`,
uploadImageFail: `Nie udało się przesłać obrazu`,
imageUploaded: `Przesłany obraz`,
setNotFound: `Nie znaleziono studiów!`,
notEnoughCards: `Za mało kart!`,
of: `__ z ___`,
on: `Na `,
off: `Wyłączony`,
auto: `Automatyczny`,
manual: `podręcznik`,
pronounce: `Wymawiać`,
practiceCompleted: `Ukończyłeś tę praktykę`,
closePractice: `Bliska praktyka`,
autoplay: `Automatyczne odtwarzanie`,
secFlipSecNext: `__ sec flip, ___ s. Następnie`,
autopronounce: `Autopronicja`,
onlyTerm: `Tylko termin`,
onlyDef: `Tylko definicja`,
termAndDef: `Termin i definicja`,
savePractice: `Zapisz praktykę?`,
continueLater: `Kontynuuj później`,
deletePractice: `Usunąć praktykę`,
term: `Termin`,
def: `Definicja`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Cel recenzji`,
dailyGoal: `Codzienny cel`,
edit: `Edytować`,
setUp: `Organizować coś`,
noRecentPractice: `Nie masz żadnych najnowszych praktyk`,
continueLastReview: `Kontynuuj ostatnią recenzję`,
dueCards: `Należne karty`,
studyNow: `Uczyć się teraz`,
newCards: `Nowe karty`,
terms: `warunki`,
defs: `Definicje`,
validCardsOf: `Tylko __ wybranych kart ___ można praktykować, ponieważ pozostałe brakuje terminu lub definicji`,
reviewCards: `Karty recenzji`,
customizePractice: `Dostosuj praktykę`,
next: `Następny`,
iWasRight: `miałem rację`,
printProAlert: `Prosimy o zakup subskrypcji pro, aby wydrukować ponad 20 fiszek`,
print: `Wydrukować`,
printWidth: `Szerokość terminu`,
printFont: `Rozmiar czcionki`,
printBorder: `Granica`,
printMargin: `Margines strony`,
printPadding: `Wyściółka słów`,
preparingFile: `Przygotowanie pliku`,
notificationsBlocked: `Powiadomienia nie są włączone, włączasz powiadomienia z ustawień telefonu`,
ranOutOfWords: `Zabrakło kart, uruchom ponownie praktykę, aby zacząć od nowa`,
ranOutOfWordsShort: `Słowa zabrakło słów`,
ranOutOfWordsBody: `Otwórz aplikację, aby zaplanować nowe słowa`,
proIncreaseNotifications: `Możesz zwiększyć całkowite powiadomienia z 10 do 50 w wersji premium.`,
schedule: `Harmonogram`,
frequency: `Częstotliwość`,
mode: `Tryb`,
tM1: `1 minuta`,
tM2: `2 minuty`,
tM5: `5 minut`,
tM10: `10 minut`,
tM15: `15 minut`,
tM30: `30 minut`,
tH1: `1 godzina`,
tH2: `2 godziny`,
termPassive: `Termin pasywny`,
termActive: `Termin aktywny`,
defPassive: `Def pasywny`,
defActive: `Def aktywny`,
scheduledIn: `Zaplanowane w __ mins`,
scheduledAlertsProT: `Zwiększ zaplanowane alerty za pomocą pro`,
scheduledAlertsProB: `Możesz zwiększyć zaplanowane alerty z 10 do 50 za pomocą pakietu pro`,
seeFeatures: `Zobacz funkcje`,
defAndTerm: `Definicja i termin`,
termHoldDef: `Termin, trzymaj definicję ujawnienia`,
defHoldTerm: `Definicja, trzymaj termin ujawniający`,
notificationType: `Typ powiadomienia`,
copyToClipboard: `Skopiuj do schowka`,
enterAuthCode: `Wprowadź swój kod autoryzacji`,
invalidCode: `Nieprawidłowy kod`,
copied: `Skopiowane!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Stuknij, aby odkryć wszystkie funkcje premium, aby uczyć się bardziej efektywnie w swoim własnym tempie`,
promoBtn: `Odkryj wszystkie funkcje`,
setDropboxH2: `Synchronizacja Dropbox`,
setDropboxPOff: `Włącz Dropbox Sync, aby przechowywać zestawy, flashce, tagi i postępy zapasowe i aktualizowane we wszystkich urządzeniach.`,
setDropboxPOn: `Twoje dane są kopie zapasowe i synchronizowane na urządzeniach.`,
setDropboxBtn: `Synchronizacja`,
status: `Status`,
syncNow: `Synchronizuj teraz`,
contact: `Kontakt`,
contactUs: `Skontaktuj się z nami`,
useFromBrowser: `Użyj z przeglądarki`,
useFromBrowserMsg: `Odwiedź FlashCardsmadesimple.com na komputerze i przywróć swoje karty i licencję, włączając Dropbox Sync`,
termsPrivacy: `Warunki i prywatność`,
dailyReviewGoal: `Cel codziennego przeglądu`,
numberTerms: `Liczba terminów`,
selectTerm: `Wybierz z wskazówką terminową`,
selectDef: `Wybierz z wskazówką definicji`,
pronounceTerm: `Wymawiaj z wskazówką terminową`,
pronounceDef: `Wymawiaj z wskazówką definicji`,
typeTerm: `Wpisz z wskazówką terminową`,
typeDef: `Wpisz z wskazówką definicji`,
quizTypes: `Preferowane typy quizów`,
spacedRepetition: `Rozprzestrzenione harmonogram powtórzeń`,
spacedRepetitionP: `Odstępowane powtórzenie pozwala opanować słowa z mniejszym wysiłkiem poprzez stopniowo rozstawienie czasu recenzji. Domyślny harmonogram to 1-3-7-15-31 dni, ale możesz również skonfigurować niestandardowy.`,
spacedRepetionScheduleItem: `__ dni po ___ przegląd (dzień ____)`,
atLeastOneSchedule: `Wymagany jest co najmniej jeden harmonogram`,
revisionLimitReached: `Osiągnąłeś maksymalną liczbę revsision`,
addReviewSchedule: `Dodaj nowy harmonogram przeglądu`,
autoMarkLearnt: `Auto Mark nauczył się po`,
autoMarkMastered: `Auto Mark opanował`,
tagManager: `Menedżer tagów`,
delete: `Usunąć`,
addTag: `Dodaj nowy tag`,
tagDeletionH: `Usuwanie tagu`,
tagDeletionP: `Czy na pewno chcesz usunąć ten tag?`,
cancel: `Anulować`,
daysAfterLastReview: `Dni po ostatniej recenzji`,
linkDropbox: `Link Dropbox`,
startSync: `Rozpocznij synchronizację`,
starred: `Wystąpił`,
images: `Obrazy`,
tags: `Tagi`,
types: `Typy`,
activeDays: `Aktywne dni`,
inactiveDays: `Nieaktywne dni`,
longestStreak: `Najdłuższa seria`,
dailyGoalsCompleted: `Codzienne cele ukończone`,
dailyGoalsFailed: `Codzienne cele nie powiodły się`,
typePairs: `Pary typu`,
reviewTypes: `Rodzaje recenzji`,
typePractice: `Wpisz praktykę`,
pronouncePractice: `Wymawiaj praktykę`,
selectPractice: `Wybierz praktykę`,
notificationReview: `Przegląd powiadomień`,
flashcardReview: `Recenzja FlashCard`,
studyset: `Studyset`,
enterStudysetName: `Wprowadź nazwę swojego studiów`,
studysetName: `Wprowadź nazwę zestawu`,
termType: `Typ terminu / lang`,
defType: `Typ definicji / lang`,
exportCards: `Karty eksportowe`,
importCards: `Karty importu`,
quiz: `Kartkówka`,
showingOutOfCards: `Pokazanie __ z kart ___`,
showingAllCards: `Pokazuj wszystkie karty, wpisz powyższy pasek wyszukiwania lub dotknij dowolnych tagów do filtrowania`,
recording: `Nagranie`,
downloadSet: `Dodaj do moich zestawów`,
addNewCard: `Dodaj nową kartę`,
saveStudyset: `Zapisz zestaw do nauki`,
studysetDeletionH: `Usuwanie studiów`,
studysetDeletionP: `Czy na pewno chcesz usunąć tę studia, to również usunie wszystkie zawarte karty.`,
cardDeletionH: `Usunięcie karty`,
cardDeletionP: `Czy na pewno chcesz usunąć tę kartę`,
cardLimitReached: `Możesz mieć tylko 3000 kart w studiach`,
limitExceeded: `Limit przekroczony`,
atLeastTenCards: `Dodaj co najmniej 10 kart, aby zacząć od praktyk`,
searchInAll: `Wyszukaj we wszystkich zestawach badań`,
noMatch: `Nie pasuje`,
atLeastThreeChars: `Wprowadź co najmniej 3 znaki, aby wyszukać`,
noSets: `Brak zestawów`,
startingSync: `Synchronizacja początkowa`,
noSetsP: `Wybierz z poniższych opcji, aby rozpocząć`,
startingSyncP: `Otrzymujemy Twoje dane z Dropbox, może to potrwać`,
createNewStudyset: `Utwórz nowe studia`,
restoreFromBackup: `Przywróć z pliku kopii zapasowej`,
setStarterPacks: `Studyset Startterpacks`,
selectPracticeType: `Wybierz typ praktyki`,
noDueCards: `Nie ma jeszcze należytej fiszek, flashce, które wcześniej sprawdziłeś`,
noNewCards: `Brak nowych kart do nauki`,
subscriptionH: `Kup Pro, aby cieszyć się wszystkimi funkcjami i wspierać ciągły rozwój.`,
buyLifetimePro: `Kup dożywotnie Pro za __`,
restorePurchase: `Przywróć zakup`,
termsPrivacyC: `Warunki i polityka prywatności`,
licenceShare: `Jeśli kupiłeś licencję w innym urządzeniu, możesz udostępnić ją temu urządzeniu, umożliwiając synchronizację Dropbox na obu urządzeniach`,
enterTagName: `Wprowadź nazwę znacznika`,
invalidName: `Błędna nazwa`,
create: `Tworzyć`,
name: `Nazwać`,
tagName: `Nazwa twojego tagu`,
color: `Kolor`,
back: `Z powrotem`,
rowSeparator: `Separator wierszy`,
termDefSeparator: `Termin - separator def`,
output: `Wyjście`,
inputCards: `Karty wejściowe`,
review: `Recenzja`,
language: `Język`,
archiveReversible: `Archiwum (odwracalne z ustawień)`,
deletePermanent: `Usuń (nieodwracalne)`,
archivedCards: `Zarchiwizowane karty`,
masteredCards: `Opanowane karty`,
due: `Należny`,
reviewed: `Oceniony`,
markReviewed: `Mark recenzował`,
markMastered: `Mark opanowany`,
forXYCards: `dla kart __ ___`,
createdAtSortBy: `Data utworzenia`,
lastReviewedSortBy: `Ostatnia data przeglądu`,
reviewCountSortBy: `Liczba recenzji`,
strengthSortBy: `Wytrzymałość`,
termSortBy: `Termin alfabetyczny`,
definitionSortBy: `Alfabetyczne def.`,
ascSortBy: `Wznoszący się`,
descSortBy: `Schodzenie`,
featureSync: `Przestudiuj wszystko, w dowolnym miejscu, w dowolnym momencie z synchronizacją fiszek na wszystkich urządzeniach`,
featureSpacedrepetition: `Spójrz na swój ogólny postęp i wróć do ćwiczenia tego, czego potrzebujesz, aby ćwiczyć`,
featureNotifications: `Nałóż naukę, nawet nie otwierając aplikacji elastycznymi powiadomieniami`,
featureFlashcards: `Autoplay Flashcards, gdy twoje ręce lub oczy są zajęte, ale nadal masz nieużywaną uwagę`,
featureQuiz: `Dopasuj, przeliteruj, słuchaj lub wybierz, aby ćwiczyć swoje fiszki`,
featureStats: `Zdobądź lepszy wgląd w swoje karty i wyniki oraz przeszukaj wszystkie zestawy flashCard`,
featureImport: `Nigdy nie będziemy przechowywać żadnych danych i możesz łatwo wyeksportować i importować wszystkie swoje dane`,
featurePrint: `Zrób naukę, drukując swoje fiszki i majsterkowicz własny zestaw do nauki`,
splashIntro: `Przestudiuj wszystkie swoje fiszki w dowolnym miejscu w tempie i stylu`,
selectSortOrder: `Sortować zamówienie`,
selectSortProp: `SORT WŁAŚCIWOŚĆ`,
applyFilters: `Zastosuj filtry`,
selectSetType: `Co chcesz ćwiczyć?`,
getStarted: `Zaczynaj`,
tapToUnarchive: `Stuknij karty, które chcesz niezarżetować`,
untitled: `Nieuprawny`,
sortHintNew: `zobaczysz karty, które zostały najpierw utworzone najdłużej`,
sortHintDue: `zobaczysz karty, które miały być najdłużej`,
sortHintOther: `zobaczysz karty, które nie były najdłużej badane`,
flashcardsWhen: `, kiedy twoje ręce lub oczy są zajęte, nawet podczas słuchania muzyki / podcastów`,
notificationsWhen: `, bo kiedy jesteś poza domem i po prostu chcesz szybkich bitów naukowych`,
quizWhen: `, bo kiedy możesz zwrócić uwagę na studia, opanować swoje karty`,
features: `Cechy`,
ratings: `Oceny`,
notificationDailyCatchUpBody: `NOWOŚĆ: __, należne: ___, nauka: ____, wyuczona: _____, opanowany: ______`,
notificationDailyCatchUpTitle: `Codzienne dogrywki`,
reviewedJN: `Sprawdzone właśnie teraz`,
customUpdated: `Zaktualizowany tekst niestandardowy`,
customTextField: `Synonimy, przykłady itp.`,
field: `Pole`,
link: `Połączyć`,
backToParentCard: `Powrót do karty rodziców`,
discard: `Odrzucać`,
failedImageLoad: `Nie udało się załadować obrazu, upewnij się, że jesteś podłączony do Internetu`,
printDIYLabel: `DIY własna konfiguracja opartego na papierze kreatywnym, podziel się z nami swoim dziełem i otrzymaj w aplikacji.`,
reviewGraphChart: `Przegląd częstotliwości`,
langNotSet: `Język nie ustawiony`,
pronouncationLangInfo: `Aby włączyć wymowę, musisz wybrać język terminu i definicji. Znak głośnika pojawi się obok języków, jeśli urządzenie obsługuje ten język`,
clearFilters: `Czysty filtr`,
subFreeUnlimited: `Nieograniczone studia, fiszki, praktyki, wyszukiwanie i synchronizacja`,
customFields: `Pola niestandardowe`,
subLinks: `Linki kart`,
subPrint: `Drukuj / studia`,
subNotifications: `Powiadomienie przed otwarciem aplikacji`,
subCardsStudysets: `Karty / studia`,
subRevisionCycles: `Niestandardowe cykle rewizji`,
subscriptionHEnd: `Uaktualnienie do Pro pokazuje nam, że uważasz, że nasza ciężka praca jest cenna i daje nam zachętę i kawę, aby kontynuować poprawę i tworzenie nowych niesamowitych rzeczy.`,
subFree: `Wolny`,
subPro: `Zawodowiec`,
guideSpacedRepetition: `W jaki sposób typy powtórzeń i praktyki rozstawione`,
guideSearch: `Wyszukiwanie i filtrowanie`,
guideSync: `Włącz kopię zapasową i zsynchronizuj na swoich urządzeniach`,
guidePronunciation: `Włącz wymowy`,
guideImport: `Importowanie kart z wyjściowych źródeł`,
guideAccess: `Kto ma dostęp do moich danych?`,
guideData: `Jakie dane zbieramy?`,
guideContact: `Potrzebujesz pomocy z czymś innym? Napisz do nas`,
arrowStrength: `Ustaw, jak dobrze znasz tę kartę`,
arrowImage: `Dodaj obrazy`,
arrowField: `Dodaj dodatkowe niestandardowe pola tekstowe`,
arrowTag: `Dołącz tagi`,
arrowStar: `Mark jako ulubiony`,
arrowLink: `Link do innych kart`,
arrowGoal: `Ustaw dla siebie codzienny cel recenzji`,
arrowDue: `Studiuj słowa, które mają zostać poddane przeglądowi`,
arrowNew: `Karty do nauki, które nie zostały jeszcze sprawdzone`,
arrowMastered: `Jeśli nie masz żadnych należnych lub nowych kart, możesz przejrzeć opanowane karty, aby je opanować`,
arrowImport: `Zaimportuj istniejące fiszki`,
arrowNewCard: `Dodaj nowe flashcards`,
dropboxStep1: `1. Uzyskaj kod dostępu z Dropbox, logując się`,
dropboxStep1Btn: `Zaloguj się z Dropbox`,
dropboxStep2: `2. Wprowadź kod dostępu poniżej`,
dropboxStep2Input: `Wprowadź kod tutaj`,
dropboxStep3: `3. Rozpocznij synchronizację`,
alreadyLinked: `Już połączone, dotknij, aby unlink`,
selectCardsToLink: `Wybierz karty do linku`,
unsupportedLangP: `Wybierz język, który obsługuje wymawianie z ustawień zestawu`,
links: `Spinki do mankietów`,
emailUs: `Wyślij nam email`,
whatsappUs: `Whatsapp nas`,
printMinHeight: `Min. Wysokość wiersza`,
exportType: `Typ pliku eksportu`,
generateFileText: `Generować plik`,
generatatingFile: `Generowanie pliku`,
verySmall: `Bardzo mały`,
small: `Mały`,
normal: `Normalna`,
big: `Duży`,
veryBig: `Bardzo duży`,
repeatNTimes: `Powtórz __ razy`,
pause: `Pauza`,
for: `dla`,
say: `Mowić`,
defShort: `Definicja.`,
times: `czasy`,
autoplayPreferences: `Ustaw preferencje automatyczne`,
autoPlay1: `Zatrzymaj się po poprzednim słowie`,
autoPlay2: `Liczba wymowa terminowych`,
autoPlay3: `Zatrzymaj się przed ujawnieniem definicji`,
autoPlay4: `Liczba wymowa definicji`,
autoPlay5: `Zatrzymaj się przed pokazaniem następnego słowa`,
autoPlay6: `Powtórz tę samą flashCard`,
startAutoPlay: `Rozpocznij autoplację`,
autoPlayOffConfirm: `Wyłącz autoplację, aby umożliwić ręczne sterowanie`,
turnOff: `Wyłączyć`,
keepPn: `Kontynuuj`,
foundIn: `Znalezione w __`,
repeat: `powtarzać`,
stop: `Zatrzymać`,
listenInBreak: `Czy wiedziałeś? Możesz słuchać muzyki / podcastów w przerwach`,
contextSearch: `Wyszukiwanie kontekstu`,
contextSearchText: `Uzyskaj przykłady, w jaki sposób __ używane w różnych zdaniach`,
transalteSearch: `Tłumaczyć`,
translateSearchText: `Przetłumacz na ___`,
synonymSearch: `Wyszukiwanie synonimów`,
synonymSearchText: `Szukaj synonimów __`,
selectToAdd: `Wybierz wyniki, które chcesz dodać do tej karty`,
addToCard: `Dodaj wybrany do karty`,
hideFromPractice: `Ukryj się w okrągłym`,
setLanguageRequired: `Wybierz język warunków i definicji w szczegółach studiów`,
fieldNeedsText: `Wprowadź coś do tego pola przed przeszukaniem`,
possibleDupe: `Możliwy duplikat`,
loadNextXCards: `Załaduj następne __ karty`,
repeatPractice: `Powtórz te __ karty`,
keepScreenOnInfo: `Może być konieczne dostosowanie ustawienia automatycznego blokowania, aby utrzymać ekran podczas automatycznego rozpowszechniania.`,
siteLoginH2: `Konto SFM`,
siteLoginP: `Możesz użyć prostego konta Flashcards, aby udostępnić swoje fiszki znajomym, uczniom lub całej społeczności.`,
logOut: `Wyloguj`,
logIn: `Zaloguj sie`,
createAccount: `Stwórz nowe konto`,
signUp: `Zapisać się`,
username: `Nazwa użytkownika`,
email: `E-mail`,
password: `Hasło`,
networkError: `Błąd sieci`,
fillAllDetails: `Wypełnij wszystkie szczegóły`,
noUserWithDetails: `Nie znaleziono użytkownika z wprowadzonymi szczegółami`,
userAlreadyExists: `Dany e -mail lub nazwa użytkownika już istnieje`,
signUpOrLoginToCont: `Zarejestruj się lub zaloguj się, aby kontynuować?`,
atLeastOneCardToShare: `Do podzielenia się co najmniej jedna karta`,
publishingStudyset: `Publishing Studyset`,
updatesDetected: `Wykryte aktualizacje, czy chcesz kontynuować aktualizację danych lokalnych? (Usunięto: __, zaktualizowano: ___, nowy: ____)`,
updatesApplied: `Zastosowane aktualizacje`,
alreadyUpToDate: `Już na bieżąco`,
practiceTypeArrow: `Odkryj różne sposoby wzroku`,
share: `Udział`,
sharingModalIntro: `Podziel się swoimi fiszkami w tym zestawie znajomym, uczniom lub całej społeczności.`,
whatIsShared: `Co jest udostępniane`,
whatIsNotShared: `Co nie jest udostępniane`,
whatIsSharedText: `Ustaw nazwę, Ustaw język terminowy, język definiton, wszystkie zawarte karty z warunkami, definicją, niestandardowymi pola tekstowe i obrazy`,
whatIsNotSharedText: `Wszelkie mocne strony, gwiazdy, linki, tagi i historia recenzji`,
checkForSharedUpdates: `Sprawdź aktualizacje od twórcy`,
fetchUpdates: `Pobierać aktualizacje`,
youSharedStudyset: `Udostępniłeś tę studia`,
publishChanges: `Zapisz i publikuj zmiany`,
redeem: `Odkupić`,
noAds: `Bez reklam`,
dupeDetection: `Duplikat wykrywania`,
coffeeFeature: `Kawa, aby pomóc nam opracować więcej funkcji`,
shareLink: `Udostępnij link`,
coffeeForUs: `Otrzymasz licencję na całe życie tylko dla __, która daje Emily 6 kaw, Dominika 3 kawy i kawy Russ 3, które napędzają nas przez około 39 godzin, aby ulepszyć to wydarzenie aplikacji`,
sharingCards: `Udostępnianie kart`,
published: `Opublikowany`,
alreadyHaveAccount: `Posiadasz już konto?`,
notAlreadyHaveAccount: `Nie masz jeszcze konta?`,
startPractice: `Rozpocznij praktykę`,
selectQuizTypes: `Wybierz typy quizów`,
correct: `Prawidłowy`,
incorrect: `Błędny`,
yes: `tak`,
no: `Nie`,
levelSilver: `Srebrny poziom __`,
levelGold: `Poziom złota __`,
levelPlatinum: `Poziom platyny __`,
levelDiamond: `Poziom diamentu __`,
levelJade: `Jade poziom __`,
reviewsLeftGoal: `__ Recenzje codziennego celu`,
dailyGoalAchieved: `Osiągnięto codzienny cel`,
share: `Udział`,
rateApp: `Oceń aplikację`,
allStats: `Wszystkie statystyki`,
reviewTimeError: `Limit czasu po błędach`,
reviewTimeCorrect: `Limit czasu po poprawnym`,
pronounceTermAfterReview: `Wymawianie terminu po przeglądzie`,
pronounceDefinitionAfterReview: `Definicja wypowiedzi po przeglądzie`,
practice: `Ćwiczyć`,
notificationsScheduledInfo: `__ Powiadomienia zostały zaplanowane, możesz zamknąć aplikację teraz`,
wellDone: `Bardzo dobrze`,
keepItUp: `Tak trzymaj`,
youRock: `Rządzisz`,
niceOne: `Niezłe`,
lnSelect: `Wybierz język`,
sampleData: `Brak recenzji, pokazując przykładowe dane`,
reviewFreq: `Przegląd częstotliwości`,
selectPractice: `Ćwicz: Wybierz`,
spellPractice: `Praktyka: zaklęcie`,
connectPractice: `Ćwicz: Połącz`,
languages: `Języki`,
languagesPairs: `Pary językowe`,
shareArrow: `Udostępnij zestaw z przyjaciółmi, studentami lub całą społecznością`,
cardsPerRound: `Karty / okrągłe`,
showAll: `Pokaż wszystko`,
supportedLangsVary: `Obsługiwane języki różnią się`,
practiceWithoutSave: `Praktyka nie została uratowana`,
practiceWithoutSaveBody: `Nie dodałeś tej studiów do swojej kolekcji, czy chcesz ją teraz dodać, aby zaoszczędzić swoje postępy?`,
saveSetNow: `Zapisz karty do swojej kolekcji`,
continueWithoutSaveSave: `Rozpocznij praktykę bez zapisu`,
createdBy: `Stworzone przez`,
setSavedToYourCollection: `Zestaw nauki zapisany w Twojej kolekcji`,
accountBackupDisclaimer: `Należy pamiętać, że to konto może być używane wyłącznie do udostępniania studiów z innymi i nie może być używane do tworzenia kopii zapasowych lub synchronizacji studiów lub fiszek. Aby zsynchronizować i tworzyć kopię zapasową wszystkich danych, użyj Dropbox Sync`,
syncEnabled: `Włączona synchronizacja, przyciągając w toku Twoją treść`,
searchAllSets: `Zestawy badań wyszukiwania od innych użytkowników`,
anyLanguage: `Każdy język`,
trendingIn: `Trend w`,
manualBackups: `Ręczne kopie zapasowe`,
manualBackupCreate: `Utwórz ręczną kopię zapasową`,
confirmManualImport: `Czy na pewno chcesz zastąpić wszystkie bieżące dane na tę kopię zapasową? Jest to zalecane tylko na nowych urządzeniach bez żadnych danych`,
importFromManualBackup: `Importować z kopii zapasowej`,
imgOfflineSets: `Automatyczne obrazy do nauki offline`,
unsupportedDeviceCache: `Ta funkcja jest dostępna tylko w aplikacji iOS lub Android`,
shareChanges: `Udostępnij __ Zmiany`,
publiclySearchable: `Wyszukiwanie przez użytkowników`,
description: `Opis`,
restoreFromDropboxBackup: `Przywróć z kopii zapasowej Dropbox`,
imageCacheStudysetSub: `[iOS i Android] Pobierz obraz do studiowania offline`,
keywordsOrLangNeeded: `Musisz wprowadzić niektóre słowa kluczowe lub jeden język`,
dropboxAlreadyLinked: `Konto Dropbox jest już połączone`,
noSetUpdateAccess: `Nie masz dostępu do edycji tego zestawu badań.`,
confirmSetOwnerLogin: `Jeśli jesteś pewien, że jesteś właścicielem, spróbuj ponownie zalogować się na swoje konto.`,
uninitedRestriction: `Aby zaoszczędzić swoje postępy, najpierw musisz dodać tę studia do swojej kolekcji`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Nie udało się skonsolidować przechowywania`,
consolidateStorageDone: `Przed zalogowaniem się na nowe urządzenie do przechowywania, poczekaj do godziny, aby Dropbox zakończył usuwanie starych plików.`,
consolidatingStorage: `Konsolidowanie przechowywania ...`,
deleteAccount: `Usuń konto`,
consolidateStorageDescription: `Ta operacja będzie powtórzyć pliki twoich kopii zapasowych, więc konfigurowanie nowych urządzeń będzie szybsze`,
consolidatingStorageConfirm: `Upewnij się, że wszystkie zmiany już zakończyły synchronizację, nie synchronizuj innych urządzeń podczas tego procesu. Czy chcesz kontynuować?`,
consolidateStorage: `Skonsoliduj przechowywanie`,


}